import { render, staticRenderFns } from "./OtpVerify.vue?vue&type=template&id=421f6026&"
import script from "./OtpVerify.vue?vue&type=script&lang=js&"
export * from "./OtpVerify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports